import { hasFocusVisible } from 'Functions/helpers';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

if (!hasFocusVisible()) {
    document.body.classList.add('without-focus-visible')
}

$(function() {
    if (window.location.hash == '#open-switch-modal') {
        $('#switch-modal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
});